import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  AuthorizedPayload,
  ConfirmSignUpPayload,
  ForgotPasswordPayload,
  ResendSignUpPayload,
  SignInPayload,
  SignUpPayload,
  SubmitForgotPasswordPayload,
  User,
} from './types';

export const signInAsync = createAsyncAction('auth/SIGN_IN_REQUEST', 'auth/SIGN_IN_SUCCESS', 'auth/SIGN_IN_FAILURE')<
  SignInPayload,
  void,
  AuthError
>();

export const signOutAsync = createAsyncAction(
  'auth/SIGN_OUT_REQUEST',
  'auth/SIGN_OUT_SUCCESS',
  'auth/SIGN_OUT_FAILURE',
)<void, void, AuthError>();

export const signUpAsync = createAsyncAction('auth/SIGN_UP_REQUEST', 'auth/SIGN_UP_SUCCESS', 'auth/SIGN_UP_FAILURE')<
  SignUpPayload,
  string,
  AuthError
>();

export const resendSignUpAsync = createAsyncAction(
  'auth/RESEND_SIGN_UP_REQUEST',
  'auth/RESEND_SIGN_UP_SUCCESS',
  'auth/RESEND_SIGN_UP_FAILURE',
)<ResendSignUpPayload, void, AuthError>();

export const confirmSignUpAsync = createAsyncAction(
  'auth/CONFIRM_SIGN_UP_REQUEST',
  'auth/CONFIRM_SIGN_UP_SUCCESS',
  'auth/CONFIRM_SIGN_UP_FAILURE',
)<ConfirmSignUpPayload, void, AuthError>();

export const forgotPasswordAsync = createAsyncAction(
  'auth/FORGOT_PASSWORD_REQUEST',
  'auth/FORGOT_PASSWORD_SUCCESS',
  'auth/FORGOT_PASSWORD_FAILURE',
)<ForgotPasswordPayload, void, AuthError>();

export const submitForgotPasswordAsync = createAsyncAction(
  'auth/SUBMIT_FORGOT_PASSWORD_REQUEST',
  'auth/SUBMIT_FORGOT_PASSWORD_SUCCESS',
  'auth/SUBMIT_FORGOT_PASSWORD_FAILURE',
)<SubmitForgotPasswordPayload, void, AuthError>();

export const getPermissionAsync = createAsyncAction(
  'auth/GET_PERMISSION_REQUEST',
  'auth/GET_PERMISSION_SUCCESS',
  'auth/GET_PERMISSION_FAILURE',
)<User, string[], Error>();

export const exchangeTokenAsync = createAsyncAction(
  'auth/EXCHANGE_TOKEN_REQUEST',
  'auth/EXCHANGE_TOKEN_SUCCESS',
  'auth/EXCHANGE_TOKEN_FAILURE',
)<void, { token: string }, Error>();

export const getAuthorizedUserAsync = createAsyncAction(
  'auth/GET_AUTHORIZED_USER_REQUEST',
  'auth/GET_AUTHORIZED_USER_SUCCESS',
  'auth/GET_AUTHORIZED_USER_FAILURE',
)<void, void, Error>();

export const setAuthorizedUser = createAction('auth/SET_AUTHORIZED_USER')<AuthorizedPayload>();

export const setGuest = createAction('auth/SET_GUEST')<boolean>();

export const clearLocalApiToken = createAction('auth/CLEAR_LOCAL_API_TOKEN')();
